<template>
  <v-menu v-model="value" v-bind="$attrs" :origin="origin" transition="scale-transition">
    <template #activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>
    <slot></slot>
  </v-menu>
</template>

<script>
export default {
  name: "MenuMore",
  props: {
    origin: {
      type: String,
      default: () => "top right",
    },
  },
  data() {
    return {
      value: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.$emit("open");
      } else {
        this.$emit("close");
      }
    },
  },
};
</script>

<style></style>
